import {combineReducers} from "redux";

import teacherReducer from "../TeachersComponent/reducers";
import studentReducer from "../StudentsComponent/reducers";


export default combineReducers({
    teacherReducer,
    studentReducer
});
